import { useEffect, useState } from "react";
import axios from "axios";
import i18n from "i18next";
import { createRequestJSON } from "utils";
import { API_URL } from "consts";
import { getURL, getTypedVal } from "utils/urls";
import type { IFetchParams, IFetchResult, SelectResultResponse } from "../types";

export const useSelectResultFetch = ({
  familyConfig,
  roadLayoutConfig,
  roadwayConfig,
  lightingClassConfig,
  luminaireLayoutConfig,
  optimizationConfig,
}: IFetchParams): IFetchResult => {
  const [data, setData] = useState<SelectResultResponse | null>(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState<{ message: string | null }>({ message: null });

  const portfolioId = getTypedVal("portfolio_id");

  useEffect(() => {
    const dataToSubmit = createRequestJSON(
      portfolioId,
      familyConfig,
      roadLayoutConfig,
      roadwayConfig,
      lightingClassConfig,
      luminaireLayoutConfig,
      optimizationConfig
    );

    const urlParams = getURL();
    const searchParams = new URLSearchParams(urlParams);
    (dataToSubmit.request.params.filter.color as string[] | undefined) = searchParams.get("color") ? searchParams.get("color")?.split(",") : undefined;
    (dataToSubmit.request.params.filter.flux as string[] | undefined) = searchParams.get("flux") ? searchParams.get("flux")?.split(",") : undefined;
    (dataToSubmit.request.params.filter.optic as string[] | undefined) = searchParams.get("optic") ? searchParams.get("optic")?.split(",") : undefined;

    let language = i18n.resolvedLanguage;
    if (!language) {
      language = "en";
    }

    const url = API_URL + "/api/find-street/";

    axios
      .post<SelectResultResponse["data"]>(url, dataToSubmit)
      .then((returnedData) => {
        setData(returnedData as SelectResultResponse);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.toJSON());
        setLoading(false);
      });
  }, [familyConfig, lightingClassConfig, luminaireLayoutConfig, optimizationConfig, roadLayoutConfig, roadwayConfig]);

  return { data, isLoading, error };
};
